module.exports = __webpack_public_path__ + "static/media/night-icon.7c9bea86.svg";